import React, { Suspense, lazy } from "react";
import NewHeroSection from "../newlandingpage/NewHeroSection";

const NewSolution  = lazy(() => import("../newlandingpage/NewSolution"));
const Connectors   = lazy(() => import("../newlandingpage/Connectors"));
const Who          = lazy(() => import("../newlandingpage/Who"));
const Works        = lazy(() => import("../newlandingpage/Works"));
const Connections  = lazy(() => import("../newlandingpage/Connections"));
const FooterHeader = lazy(() => import("../newlandingpage/FooterHeader"));
const Footer       = lazy(() => import("../compnents/footer"));

const Home = () => {
  return (
    <div className="jakarta">
      <NewHeroSection />
      <Suspense fallback={null}>
        <NewSolution />
        <Connectors />
        <Who />
        <Works />
        <Connections />
        <FooterHeader />
        <Footer />
      </Suspense>
    </div>
  );
};

export default Home;
